export const ENTERPRISE = "enterprise";
export const DATA_TABLES = "data_tables";
export const NO_ACCESS = "no_access";
export const TEMP = "temp";
export const PERM = "perm";

export const TEMP_SPEND_TITLE = "Spend Total by Work Period";
export const TEMP_SPEND_TOOLTIP =
  "What you have been billed and is grouped by when it was worked.";
export const TEMP_SPEND_BY_AGENCY_TOOLTIP =
  "Spend total by staffing firm during this period.";

export const HEADCOUNT = "Headcount";
export const TEMP_HEADCOUNT_TOOLTIP =
  "Number of unique workers active during the period.";
export const TEMP_HEADCOUNT_BY_AGENCY_TOOLTIP =
  "Headcount by staffing firm during this period.";
